import { useEffect, useState } from 'react';
import Modal from '../Modal/CenterModal';

function ModalContainer({
  onModalClose = () => { },
  btnComponent,
  content,
  title,
  subtitle,
  xl,
  lg,
  sm,
  padding,
  isCloseAble,
  isOpen,
  imgPreview,
  width,
  helpModal,
  noHead,
  newStyle,
  closeClick,
  stateChanged = () => { },
}) {
  const [isVisible, setIsVisible] = useState(!!isOpen);
  const [p_isVisible, p_setIsVisible] = useState(!!isOpen);
  const showModal = () => {
    setIsVisible(true);
    p_setIsVisible(true);
  };
  const handleCancel = () => {
    setIsVisible(false);
  };


  useEffect(() => {
    if (p_isVisible && !isVisible) {
      stateChanged({ [title]: false });
      onModalClose();
    }
  }, [isVisible]);

  return (
    <>
      {btnComponent && btnComponent({ onClick: showModal })}
      <Modal
        title={title}
        subtitle={subtitle}
        open={isVisible}
        setOpen={setIsVisible}
        xl={xl}
        lg={lg}
        sm={sm}
        padding={padding}
        width={width}
        isCloseAble={isCloseAble}
        helpModal={helpModal}
        noHead={noHead}
        newStyle={newStyle}
        imgPreview={imgPreview}
        closeClick={closeClick}>
        {content({ onClose: handleCancel })}
      </Modal>
    </>
  );
}

export default ModalContainer;
